
import { SWRConfiguration, SWRResponse } from "swr";

import { IReturn, QueryMasterGroups, QueryMasterGroupsResponse, MasterGroup } from "@/api/dtos";
import { useMemo } from "react";
import useCachedDataQuery from '@/hooks/api/useCachedDataQuery';
import { AppSettings } from "@/AppSettings";

const getAdditionalState = (response?: SWRResponse<QueryMasterGroupsResponse, QueryMasterGroupsResponse>) => ({
    idMap: !!response?.data?.data?.length ? response?.data?.data?.reduce<Record<number, MasterGroup>>((a, b) => {
        if (!b?.id) {
            return a;
        }
        
        a[b.id] = b;

        return a;
    },{}) : undefined
});

const sortData = (a: MasterGroup, b: MasterGroup) => a.name! > b.name! ? 1 : -1;

export const useMasterGroups = (query?: Partial<MasterGroup>, configuration?: SWRConfiguration | undefined) => {
    return useCachedDataQuery(QueryMasterGroups, { sortData, getAdditionalState, channel: AppSettings.channels.masterGroup }, query, configuration);
}

export default useMasterGroups;